import React, { useState, useEffect } from "react";
import "../styles.css";

export default function ModalEditarUsuario({ visible, usuario, onClose, onGuardar }) {
  const [username, setUsername] = useState(usuario?.username || "");
  const [password, setPassword] = useState("");
  const [rol, setRol] = useState(usuario?.rol || "user");

  useEffect(() => {
    if (usuario) {
      setUsername(usuario.username || "");
      setRol(usuario.rol || "user");
      setPassword("");
    }
  }, [usuario]);

  if (!visible || !usuario) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      id: usuario.id,
      username: username || usuario.username,
      password: password || undefined,
      rol,
    };

    await onGuardar(payload);
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-ancho">
        <button
          className="modal-close-btn"
          onClick={onClose}
        >
          ×
        </button>

        <h2 className="modal-title">
          Editar Usuario: {usuario.username}
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Usuario</label>
            <input
              type="text"
              value={username}
              disabled
              className="input-text"
            />
          </div>

          <div className="form-group">
            <label>Nueva Contraseña (opcional)</label>
            <input
              type="password"
              value={password}
              placeholder="Dejar vacío para mantener la actual"
              onChange={(e) => setPassword(e.target.value)}
              className="input-text"
            />
          </div>

          <div className="form-group">
            <label>Rol</label>
            <select
              value={rol}
              onChange={(e) => setRol(e.target.value)}
              className="select-input"
            >
              <option value="user">Usuario</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="boton botonSecundario"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="boton botonSecundario"
            >
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
